module.exports = __webpack_public_path__ + "f2e6e1517e476186c003a38cfaaf0dff.png";